"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Typography = require("./Typography.style");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["textType", "children", "component"];

var Typography = function Typography(_ref) {
  var textType = _ref.textType,
      children = _ref.children,
      component = _ref.component,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var TypographyComponent = '';

  switch (textType) {
    case 'body':
      TypographyComponent = _Typography.BodyDiv;
      break;

    case 'head':
      TypographyComponent = _Typography.HeadingDiv;
      break;

    default:
      TypographyComponent = _Typography.StyledTypography;
      break;
  }

  return /*#__PURE__*/_react["default"].createElement(TypographyComponent, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.defaultProps = {
  component: 'div',
  isItalic: false,
  ellipsis: false,
  variant: 'body4',
  size: 'XL',
  fontDecoration: 'normal'
};
Typography.propTypes = {
  component: _propTypes["default"].oneOf(['div', 'span']).isRequired,
  textType: _propTypes["default"].oneOf(['body', 'head']).isRequired,
  children: _propTypes["default"].node,
  color: _propTypes["default"].string,
  shade: _propTypes["default"].string,
  isItalic: _propTypes["default"].bool,
  fontDecoration: _propTypes["default"].oneOf(['normal', 'underline']).isRequired
};
var _default = Typography;
exports["default"] = _default;